module.exports = __webpack_public_path__ + "img/plugin-btn.390449a5.png";